import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const WorkingTimeSidebarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth="1.5">
        <path strokeLinecap="round" d="M10 7H2m6 5H2m8 5H2"/>
        <circle cx="17" cy="12" r="5"/>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 10v1.846L18 13"/>
      </g>
    </SvgIcon>
  );
};
